export default __webpack_public_path__ + "static/media/shape4.96dbdaf3.svg";